import { Dialog } from "@mui/material";
import { Check, X } from "lucide-react";

const SuccessDialog = ({ open, message, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          maxWidth: "520px",
          padding: "40px 30px",
          textAlign: "center",
        },
      }}
    >
      <div className="relative flex flex-col items-center">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-0 top-0 text-gray-500 hover:text-black"
        >
          <X size={22} />
        </button>

        {/* Success Icon */}
        <div className="">
          <img
            src="/success.gif"
            alt="Success"
            className="w-20 h-20  flex items-center justify-center mb-6"
          />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Add Details Successfully!
        </h2>

        {/* Message */}
        <p className="text-gray-500 text-base max-w-sm">
          {message ||
            "Bachelor's details added successfully. Changes are now live."}
        </p>
      </div>
    </Dialog>
  );
};

export default SuccessDialog;
